module.exports = __webpack_public_path__ + "img/empty-msg.a927fe81.png";